import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'

import {find, assign} from 'lodash'

let consistencyLogs = []
let databaseLogs = []

export default {
  getConsistencyLogsPointer () {
    return consistencyLogs
  },
  getDatabaseLogsPointer () {
    return databaseLogs
  },
  getConsistencyLogs (options) {
    /*
      options: {
        data: {
          distributorCode2: ''
        },
        onSuccess: () => {},
        onError: () => {}
      }
    */
    // PODRIA HACER UNA CONFIRMACION ANTES DE HACER EL POST
    // PREGUNTANDO SI ESA DATA YA EXISTE
    // CONSULTAR SI SE DEBE HACER ASI
    axios.post(uris.URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS, {
      distributorCode2: options.data.distributorCode2
    })
      .then((response) => {
        let log = {
          distributorCode2: options.data.distributorCode2,
          logs: response.data.rows,
          logType: 'CONSISTENCY'
        }
        let extantLog = find(consistencyLogs, (item) => {
          return item.distributorCode2 === options.data.distributorCode2
        })

        extantLog ? assign(extantLog, log) : consistencyLogs.push(log)

        if (options.onSuccess) {
          options.onSuccess(consistencyLogs)
        }
      }, (err) => {
        console.warn('ERROR GETTING CONSISTENCY LOGS', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  getDatabaseLogs (options) {
    /*  */
    axios.post(uris.URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS, {
      distributorCode1: options.data.distributorCode1
    })
      .then((response) => {
        let log = {
          distributorCode1: options.data.distributorCode1,
          logs: response.data.rows,
          logType: 'DATABASE'
        }
        let extantLog = find(databaseLogs, (item) => {
          return item.distributorCode1 === options.data.distributorCode1
        })

        extantLog ? assign(extantLog, log) : databaseLogs.push(log)

        if (options.onSuccess) {
          options.onSuccess(databaseLogs)
        }
      }, (err) => {
        console.warn('ERROR GETTING DATABASE LOGS', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/logsStorage.js